module.exports = __webpack_public_path__ + "static/media/outfit3.83b5ae3b.jpg";